import React from 'react';
import styles from './FigureFrame.module.css';

function FigureFrame({ label, children }) {
  return (
    <div className={styles.frame}>
      <div className={styles.titleBar}>
        <span className={styles.title}>[ {label} ]</span>
        <span className={styles.controls} aria-hidden="true">
          <span className={styles.ctrl} />
          <span className={styles.ctrl} />
          <span className={styles.ctrl} />
        </span>
      </div>
      <div className={styles.body}>{children}</div>
    </div>
  );
}

export default FigureFrame;
